module.exports = __webpack_public_path__ + "img/shape1.b986fe6a.svg";